import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>"']+)/gi;

/**
 * Split plain text on http(s) URLs and render matches as clickable links.
 * Non-URL segments are rendered as normal React text (escaped).
 */
export function linkifyText(text: string): React.ReactNode[] {
  if (!text) return [];

  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  const regex = new RegExp(URL_REGEX.source, URL_REGEX.flags);

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    const url = match[0];
    // Trim trailing punctuation commonly stuck to URLs
    const trailingMatch = url.match(/[),.;:!?]+$/);
    const trailing = trailingMatch ? trailingMatch[0] : '';
    const href = trailing ? url.slice(0, -trailing.length) : url;

    nodes.push(
      <a
        key={`${match.index}-${href}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'underline', wordBreak: 'break-all' }}
      >
        {href}
      </a>
    );
    if (trailing) {
      nodes.push(trailing);
    }
    lastIndex = match.index + url.length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length > 0 ? nodes : [text];
}
